import type { FC, SVGProps } from "react";

const IconCrosshair: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M1.66675 10H4.16675" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.8333 10H18.3333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 1.6665V4.1665" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 15.8335V18.3335" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.0001 15.8332C13.2217 15.8332 15.8334 13.2215 15.8334 9.99984C15.8334 6.77818 13.2217 4.1665 10.0001 4.1665C6.77842 4.1665 4.16675 6.77818 4.16675 9.99984C4.16675 13.2215 6.77842 15.8332 10.0001 15.8332Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconCrosshair;
